import merge from "lodash/merge";

import {
  SET_LIVE_EVENTS,
  RESET_DATA,
  SET_GOOD_DEALS_RESULT,
  SET_CITY_COMMUNITIES,
  SET_TEMPLATES,
  SET_EVENT_INTERESTED_USERS_RESULT,
  SET_GET_EVENT_DETAILS_RESULT,
  SET_TEMPLATE_DATES,
  SET_TEMPLATE_TIMES,
  SET_COMMUNITY_DETAIL,
  SET_CITIES,
  SET_CHAT_EVENTS_RESULT,
  SET_CHAT_MESSAGES
} from "../actions/types";

const initialState = {
  locations: {},
  templates: {},
  categories: {},
  goodDealsCategories: {},
  hobbies: {}
};

export default function entities(state = initialState, action) {
  switch (action.type) {
    case SET_CITIES:
    case SET_CITY_COMMUNITIES:
    case SET_LIVE_EVENTS:
    case SET_GOOD_DEALS_RESULT:
    case SET_EVENT_INTERESTED_USERS_RESULT:
    case SET_GET_EVENT_DETAILS_RESULT:
    case SET_TEMPLATE_DATES:
    case SET_TEMPLATE_TIMES:
    case SET_COMMUNITY_DETAIL:
    case SET_CHAT_EVENTS_RESULT:
    case SET_CHAT_MESSAGES:
      break;

    case RESET_DATA:
      return {
        ...initialState
      };

    case SET_TEMPLATES:
      return {
        ...state,
        categories: { ...action.entities.categories },
        templates: { ...action.entities.templates }
      };

    default: {
      if (action.entities) {
        return merge({}, state, action.entities);
      }
      break;
    }
  }
  return state;
}
